//use rafce
import React,{useState} from 'react'
import { SliderData1 } from './SliderData1'
import {FaArrowAltCircleRight,FaArrowAltCircleLeft} from 'react-icons/fa'
import styles from './ImageSlider1.module.css'

const ImageSlider1 = ({slides}) => {

    const [current,setCurrent]=useState(0)
    const length=slides.length

    const nextSlide=()=>{
        setCurrent(current === length-1? 0:current+1)
    }

    const prevSlide=()=>{
        setCurrent(current===0 ? length-1 : current-1)
    }

    if(!Array.isArray(slides) || slides.length <=0){
        return null;
    }
    
    

    return (
        <section className={styles.slider}>
            <FaArrowAltCircleLeft className={styles.left_arrow} onClick={prevSlide}/>
            <FaArrowAltCircleRight className={styles.right_arrow} onClick={nextSlide} />

            {SliderData1.map((slide,index)=>{
                return(
                    <div className={index===current ? 'slide active': 'slide'} key={index}>

                        {index===current && (<img src={slide.image} alt='images..' className={styles.image}/>)}
                        

                    </div>

                    
                )
            })}
        </section>
    )
}

export default ImageSlider1
